module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("4Y4Hb"))).then(() => parcelRequire('7ciIH'));